var map = {
	"./cooperate-item1-1.png": 8085,
	"./cooperate-item10-1.png": 6445,
	"./cooperate-item11-1.png": 7872,
	"./cooperate-item2-1.png": 8118,
	"./cooperate-item3-1.png": 8107,
	"./cooperate-item4-1.png": 9508,
	"./cooperate-item5-1.png": 1393,
	"./cooperate-item6-1.png": 5013,
	"./cooperate-item7-1.png": 5527,
	"./cooperate-item8-1.png": 4800,
	"./cooperate-item9-1.png": 9101
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1717;